import { render, staticRenderFns } from "./TextsForm.vue?vue&type=template&id=542cb302&scoped=true"
import script from "./TextsForm.vue?vue&type=script&lang=js"
export * from "./TextsForm.vue?vue&type=script&lang=js"
import style0 from "./TextsForm.vue?vue&type=style&index=0&id=542cb302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542cb302",
  null
  
)

export default component.exports